define('home/views/HomepageUserModuleView',[
    'underscore',
    'backbone-marionette',

    'home/mixins/withAllstarPopover',
    'home/templates/homepageUserModule',
], function (
    _,
    Marionette,

    withAllstarPopover,
    homepageUserModuleTemplate
) {
    'use strict';

    var HomepageUserModuleView = Marionette.ItemView.extend({
        template: homepageUserModuleTemplate,
        className: 'aside__wrap',

        templateHelpers: function () {
            return {
                numTotalFollowing: this.model.getNumTotalFollowing(),
                promptForProfileCompletion: this.shouldPromptForProfileCompletion(),
            };
        },

        /**
         * We prompt the user to complete their profile for 24 hours after they
         * created their account, and if their profile is not already complete.
         */
        shouldPromptForProfileCompletion: function () {
            var profileIsComplete = this.model.get('avatar').isCustom &&
                _.chain(this.model.attributes)
                    .pick(['name', 'about', 'url', 'location'])
                    .every()
                    .value();

            return this.model.registeredToday() && !profileIsComplete;
        },

        // Initial render waits until User details are fetched, but
        // after user's following channels are fetched the total number
        // of things he/she is following may have changed.
        modelEvents: {
            'change:numChannelsFollowing': 'render',
        },
    });

    withAllstarPopover.call(HomepageUserModuleView.prototype);

    return HomepageUserModuleView;
});

